'use client'
import { useHealthLandingStore } from "@/app/stores/health/health-landing-store";
import { useShallow } from "zustand/react/shallow";
import { useEffect } from "react";

export default function HealthLandingClientSetup({ quoteData }: { quoteData: any }) {
    const { setQuote } = useHealthLandingStore(useShallow(
        (state) => ({
            setQuote: state.setQuote,
        })
    ));

    useEffect(() => {
        if (quoteData) {
            setQuote(quoteData);
        }
    }, [quoteData, setQuote]);

    return null;  // no UI to render in this component
}
